import { useEffect } from 'react';

const TERMLY_SCRIPT_ID = import.meta.env.VITE_TERMLY_COOKIE_SCRIPT_ID;

export const TermlyScript = () => {
  useEffect(() => {
    if (!TERMLY_SCRIPT_ID) {
      console.warn('Termly script not configured');
      return;
    }

    // Load Termly cookie consent script
    const script = document.createElement('script');
    script.src = 'https://app.termly.io/embed.min.js';
    script.setAttribute('data-auto-block', 'on');
    script.setAttribute('data-website-uuid', TERMLY_SCRIPT_ID);
    script.async = true;
    
    document.head.appendChild(script);

    return () => {
      // Clean up script on unmount
      if (document.head.contains(script)) {
        document.head.removeChild(script);
      }
    };
  }, []);

  return null;
};
